import React from 'react';
import { DashboardOverview } from '../components/organisms/DashboardOverview';
import { StockWatchlist } from '../components/organisms/StockWatchlist';
import { OrdersPanel } from '../components/organisms/OrdersPanel';
import { AlertsPanel } from '../components/organisms/AlertsPanel';

export const DashboardPage: React.FC = () => (
  <div data-testid="dashboard-page">
    <DashboardOverview />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <StockWatchlist />
      </div>
      <div className="space-y-8">
        <OrdersPanel />
        <div>
          <AlertsPanel />
        </div>
      </div>
    </div>
  </div>
);